import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixSearchIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M21.2851 21.2821L16.8076 16.8047"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.9682 19.2255C15.5264 19.2255 19.2216 15.5304 19.2216 10.9721C19.2216 6.41392 15.5264 2.71875 10.9682 2.71875C6.41001 2.71875 2.71484 6.41392 2.71484 10.9721C2.71484 15.5304 6.41001 19.2255 10.9682 19.2255Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
